/**
 * <lv-gallery> — Shows one [data-slide] at a time; [data-thumb] buttons pick the slide.
 */
class LvGallery extends HTMLElement {
  connectedCallback() {
    this.slides = [...this.querySelectorAll('[data-slide]')];
    this.thumbs = [...this.querySelectorAll('[data-thumb]')];
    this.thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => this.show(i));
    });
  }

  show(index) {
    this.slides.forEach((slide, i) => { slide.hidden = i !== index; });
    this.thumbs.forEach((thumb, i) => {
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }
}

if (!customElements.get('lv-gallery')) customElements.define('lv-gallery', LvGallery);
